import * as React from "react";
import { Fragment } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Input,
  Radio,
  message,
  Cascader,
  Descriptions,
} from "antd";
import { debounce } from "lodash";
import storageUtils from "@/utils/storageUtils";
import CommonUtils from "@/utils/commonUtils";
import config from "@/config/config";
import Urls from "@/config/url";
import https from "@/utils/ajaxUtils";
import { connect } from "react-redux";
import "./index.css";
import address from "./city";
import moment from "moment";

//需要渲染什么数据
function mapStateToProps(state) {
  return {
    userInfo: state,
  };
}
//需要触发什么行为
function mapDispatchToProps(dispatch) {
  return {
    PayIncrease: (v) => dispatch({ type: "change", value: v }),
  };
}

// 当前页与展示个数
// let selectData = {
//   pageSize: 10,
//   currentPage: 1,
// }

class Trade extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginInfo: JSON.parse(storageUtils.get(config.loginStorageKey)),
      userId: null,
      userInfo: null,
      totalCount: 0, //总共交易数据
      selectedRowKeys: [], //选项列表
      tableListDataSource: [], //交易数据
      len: 0, //选中的交易个数
      totalMoney: 0.0, //选中交易个数的总金额
      detail: false, //发票详情不显示
      type: 0, //类型默认为个人
      orderList: [], //选中订单的uuid
      page: 1, //当前页
      pageSize: 10,
      show: false,
      noData: false,
      relationOrderAmount: 0, //订单关联数
    };
  }
  formRef = React.createRef();
  changePasformRef = React.createRef();
  changeFormRef = React.createRef();
  componentDidMount() {
    if (!this.state.loginInfo) {
      // 没有登陆
      // console.log('没有登陆');
    } else {
      if (
        this.state.loginInfo &&
        this.state.loginInfo.loginInfo &&
        this.state.loginInfo.loginInfo.userInfo
      ) {
        this.setState(
          { userId: this.state.loginInfo.loginInfo.userInfo.id },
          () => {
            // console.log('userInfo', this.state.userInfo);
            this.getUserInfo(false);
          }
        );
        // console.log('0000000', this.state.userId)
      } else {
        // 没有获取到个人信息
        // console.log("没有获取到个人信息");
      }
    }

    // selectData = {
    //   pageSize: 10,
    //   currentPage: 1,
    // }
    // this.getUserInfo()
    this.getTableList();
  }

  // 获取用户信息
  getUserInfo = async (boo) => {
    const res = await https.get(
      Urls.getUserInfo.replace("{id}", this.state.userId),
      {}
    );
    console.log(" 用户信息: ", res);
    // if (res.success) {
    //   this.setState({
    //     userId: this.state.loginInfo.loginInfo.userInfo.id,
    //   })
    // }
    if (!res.success) {
      message.error("获取用户信息失败!");
      return;
    }
  };

  getUserName = () => {
    let userInfo = this.state.userInfo;
    if (!userInfo) {
      return null;
    }
    if (userInfo.username) {
      console.log(1);
      return userInfo.username;
    }
    if (userInfo.mobile) {
      console.log(2);
      console.log(CommonUtils.getPhoneShow(userInfo.mobile, 3, 5));
      return CommonUtils.getPhoneShow(userInfo.mobile, 3, 5);
    }
    return null;
  };

  // 注销信息 跳转到登录页面
  tologinPage = () => {
    // 清空登录信息
    storageUtils.remove(config.loginStorageKey);

    // 返回登录页
    this.props.history.push(`/Login`);
  };

  // 获取交易明细列表
  getTableList = async () => {
    // console.log(
    //   'this.state.loginInfo.loginInfo.userInfo',
    //   this.state.loginInfo.loginInfo.userInfo
    // )
    const param = {
      pageSize: this.state.pageSize,
      currentPage: this.state.page,
      userUuid: this.state.loginInfo.loginInfo.userInfo.uuid,
      state: "支付成功", // 先写死
      payPlatform: "微信", // 先写死
    };
    // 调接口
    const res = await https.get(Urls.getTableList, param);
    // console.log('3333333', res)
    if (res.success) {
      // this.setState({
      //   show: true
      // })
      const { data } = res;
      this.setState({
        tableListDataSource: data.data,
        totalCount: data.total,
      });

      if (this.state.tableListDataSource.length > 0) {
        // console.log('length', this.state.tableListDataSource.length)
        this.setState({
          show: true,
        });
      } else {
        this.setState({
          noData: true,
        });
      }
    } else {
      return (
        <div
          style={{
            width: "300px",
            height: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src="/img/no-data.png" alt="无数据" />
        </div>
      );
    }
  };

  // 分页条数选择
  // onShowSizeChange = (e, pageSize) => {
  //   if (e !== selectData.currentPage || pageSize !== selectData.pageSize) {
  //     selectData.currentPage = e
  //     selectData.pageSize = pageSize
  //     this.getTableList()
  //   }
  // }
  changePage = (page) => {
    this.setState(
      {
        page: page,
      },
      () => {
        this.getTableList();
      }
    );
  };

  //开纸质发票
  getInvoice = (item, amount, number) => {
    console.log("wwwwwww", number);
    // if (this.state.orderList.length === 0) {
    //   message.error('请先选中订单！')
    //   return
    // }
    this.setState({
      detail: true,
      relationOrderAmount: number,
    });
  };

  //发票详情右上角取消
  cancle = () => {
    this.setState({
      detail: false,
    });
  };
  // 切换用户类型
  onChangeType = (value) => {
    const val = value.target.value;
    this.setState(
      {
        type: val,
      },
      () => {
        if (this.state.type === 1) {
          this.changeFormRef.current.setFieldsValue({
            invoiceHead: "",
          });
        } else {
          this.changeFormRef.current.setFieldsValue({
            invoiceHead: "个人",
          });
        }
      }
    );
  };

  // 立即开票
  getInvoiceNow = debounce(() => {
    this.changeFormRef.current.validateFields().then((values) => {
      console.log("uiuohjh", values);
      if (this.state.totalMoney < 200) {
        const payMethod = "到货付款";
        values.payMethod = payMethod;
      } else {
        const payMethod = "包邮";
        values.payMethod = payMethod;
      }
      if (values?.consigneeRegion) {
        const arr = values?.consigneeRegion.join();

        values.consigneeRegion = arr;
        // console.log('aaaaaaaa', typeof values.consigneeRegion)
        // console.log('now', values)
      }
      // console.log('values', values)
      https.post(Urls.getInvoiceNow, values).then((res) => {
        if (res.success) {
          message.success("开票成功!");
          this.cancle();
          this.getTableList();
          this.clearCheck();
          this.setState({
            totalMoney: 0.0,
            len: 0,
          });
        } else {
          message.error(res.errMsg);
        }
      });
    });
  }, 1000);

  // 开票后处理勾选数据后清空勾选
  clearCheck = () => {
    this.setState({
      selectedRowKeys: [],
    });
  };

  changePageSize = (current, size) => {
    this.setState(
      {
        page: 1,
        pageSize: size,
      },
      () => {
        this.getTableList();
      }
    );
  };

  render() {
    const { totalCount, tableListDataSource, type } = this.state;
    // 表单项
    const columns = [
      {
        title: "订单号",
        dataIndex: "orderBid",
      },
      {
        title: "交易时间",
        dataIndex: "transactionTime",
        render: (text, record) => {
          // console.log('llllllll', text, record)
          return record?.transactionTime
            ? moment(record?.transactionTime).format("YYYY-MM-DD HH:mm:ss")
            : "";
        },
      },
      {
        title: "交易金额",
        dataIndex: "totalAmount",
      },
      {
        title: "交易平台",
        dataIndex: "payPlatform",
      },
      {
        title: "交易内容",
        dataIndex: "packageName",
      },
      {
        title: "开票状态",
        dataIndex: "invoiceState",
        // fixed: 'right',
        render: (text, record) => {
          if (record.isApplyInvoice === 1) {
            if (record.invoiceState === 1) {
              return <span style={{ color: "#00A96D" }}>已开票</span>;
            }
            if (record.invoiceState === 0) {
              return <span style={{ color: "#FF5757" }}>未开票</span>;
            }
          } else {
            return <span>- -</span>;
          }
        },
      },
      {
        title: "开票申请",
        dataIndex: "isApplyInvoice",
        render: (isApplyInvoice) => {
          if (isApplyInvoice === 1) {
            return <span>是</span>;
          }
          if (isApplyInvoice === 0) {
            return <span>否</span>;
          }
        },
      },
    ];

    // 表单自选项选择
    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      getCheckboxProps: (record) => {
        // console.log('record', record)
        if (record.isApplyInvoice === 1) {
          return { disabled: true };
        } else {
          return null;
        }
      },
      onChange: (selectedRowKeys, selectedRows) => {
        console.log(selectedRowKeys, selectedRows);
        this.setState({
          len: selectedRowKeys?.length,
          selectedRowKeys,
        });
        const arrNum = selectedRows?.map((item) => item?.totalAmount);
        let sum = 0;
        arrNum.forEach(function (val) {
          sum += val;
        });
        // console.log('kkkkkkk', sum)
        this.setState({
          totalMoney: sum.toFixed(2),
        });
        const orderList = selectedRows?.map((item) => item?.uuid);
        this.setState({
          orderList,
        });
      },
    };
    return (
      <React.Fragment>
        <div
          className="table-container"
          style={{
            overflowY: "auto",
            marginTop: 0,
            display: this.state.show ? "block" : "none",
          }}
        >
          <div className="table-tables">
            <Table
              className="table-origin"
              rowSelection={rowSelection}
              dataSource={tableListDataSource}
              rowKey={"uuid"}
              columns={columns}
              bordered
              scroll={true}
              style={{ marginTop: "10px" }}
              pagination={{
                current: this.state.page,
                total: totalCount,
                pageSize: this.state.pageSize,
                size: "small",
                showQuickJumper: true,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                onChange: this.changePage,
                onShowSizeChange: this.changePageSize,
                showTotal: (total) => {
                  // const totalPage = Math.ceil(totalCount / selectData.pageSize)
                  return "共 " + totalCount + " 条";
                },
              }}
            />
            <span className="table-order">
              {this.state.len}个订单，共计金额￥{this.state.totalMoney}
              （满200包邮）
            </span>
            {/* <span className="table-number">共{totalCount}条</span> */}
          </div>
          <div style={{ marginTop: "1rem" }}>
            <div align="middle" justify="center">
              <Button
                type="primary"
                onClick={() =>
                  this.getInvoice(this.state.type, totalCount, this.state.len)
                }
              >
                开纸质发票（预计7天内到达）
              </Button>
              <p
                style={{
                  marginTop: "0.15rem",
                  color: "#999999",
                }}
              >
                如有疑问联系客服，客服电话：023-65781234
              </p>
            </div>
          </div>
          <Modal
            visible={this.state.detail}
            destroyOnClose
            maskClosable={false}
            title="发票详情"
            width="50%"
            onCancel={() => this.cancle()}
            footer={null}
          >
            <Form
              labelCol={{
                span: 5,
              }}
              ref={this.changeFormRef}
              // onFinish={this.onFinish}
            >
              <Row
                gutter={24}
                style={{
                  marginTop: 16,
                }}
              >
                <Col span={24}>
                  <Form.Item
                    label="抬头类型："
                    name="headType"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={0}
                  >
                    <Radio.Group
                      onChange={this.onChangeType.bind(this)}
                      defaultValue={0}
                    >
                      <Radio value={1}>企业单位</Radio>
                      <Radio value={0}>个人/非企业单位</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              {type === 0 && (
                <Fragment>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="发票抬头："
                        name="invoiceHead"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                        initialValue="个人"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="发票内容："
                        name="invoiceContent"
                        rules={[
                          {
                            required: false,
                          },
                        ]}
                        initialValue="服务升级"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="发票金额："
                        name="amount"
                        rules={[
                          {
                            required: false,
                          },
                        ]}
                        initialValue={this.state.totalMoney}
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                </Fragment>
              )}
              {type === 1 && (
                <Fragment>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="发票抬头："
                        name="invoiceHead"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="税号："
                        name="taxNumber"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="开户银行："
                        name="accountOpenBank"
                        rules={[
                          {
                            required: false,
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="银行账号："
                        name="accountNumber"
                        rules={[
                          {
                            required: false,
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="注册地址："
                        name="registerAddress"
                        rules={[
                          {
                            required: false,
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="注册电话："
                        name="registerPhoneNumber"
                        rules={[
                          {
                            required: false,
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="发票内容："
                        name="invoiceContent"
                        rules={[
                          {
                            required: false,
                          },
                        ]}
                        initialValue="服务升级"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Form.Item
                        label="发票金额："
                        name="amount"
                        rules={[
                          {
                            required: false,
                          },
                        ]}
                        initialValue={this.state.totalMoney}
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                </Fragment>
              )}
              <div>
                <Descriptions size="middle" title="接收方式"></Descriptions>
              </div>
              <Row
                gutter={24}
                style={{
                  marginTop: 16,
                }}
              >
                <Col span={24}>
                  <Form.Item
                    label="收货人电话："
                    name="consigneePhoneNum"
                    rules={[
                      {
                        required: true,
                        pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
                        message: "请输入合法电话：",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item
                    label="收货人姓名："
                    name="consigneeName"
                    rules={[
                      {
                        required: true,
                        pattern: /^([\u4e00-\u9fa5]{1,20}|[a-zA-Z.s]{1,20})$/,
                        message: "请输入合法姓名：",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item
                    label="所在地区："
                    name="consigneeRegion"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Cascader
                      options={address}
                      // onChange={this.onChangeAddress}
                      placeholder="请选择所在地区"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item
                    label="详细地址："
                    name="consigneeDetailAddress"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                className="ant-form-item-control-input"
                name="orderList"
                initialValue={this.state.orderList}
              ></Form.Item>
              <Form.Item
                className="ant-form-item-control-input"
                name="relationOrderAmount"
                initialValue={this.state.relationOrderAmount}
              ></Form.Item>
              {this.state.totalMoney < 200 && (
                <Form.Item
                  style={{
                    color: "#999999",
                  }}
                  name="payMethod"
                >
                  开票金额不足200元，需要支付邮费，本平台默认采取
                  <span style={{ color: "#4B75FF" }}>到货付款</span>方式
                </Form.Item>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      marginRight: 20,
                    }}
                    onClick={this.getInvoiceNow}
                  >
                    立即开票
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </Modal>
        </div>
        <div
          style={{
            width: "300px",
            height: "300px",
            margin: "70px auto",
            display: this.state.noData ? "block" : "none",
          }}
        >
          <img src="/img/no-data.png" alt="无数据" />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            暂无数据
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Trade);
